import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Activity, Users, UserCircle, Trophy } from 'lucide-react';
import { cn } from '@/lib/cn';
import { ROUTES } from '@/app/routes';

export function BottomNav() {
  const { t } = useTranslation();
  const items = [
    { to: ROUTES.dashboard, label: t('nav.dashboard'), icon: LayoutDashboard, end: true },
    { to: ROUTES.activities, label: t('nav.activities'), icon: Activity, end: false },
    { to: ROUTES.friends, label: t('nav.friends'), icon: Users, end: false },
    { to: ROUTES.leaderboards, label: t('nav.leaderboards'), icon: Trophy, end: false },
    { to: ROUTES.profile, label: t('nav.profile'), icon: UserCircle, end: false },
  ];

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-parchment-border bg-parchment-light/95 backdrop-blur"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="mx-auto grid max-w-md grid-cols-5">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 py-2 text-xs',
                isActive ? 'text-accent' : 'text-parchment-muted',
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span className="text-[11px] font-medium">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
